$(document).ready ->
  # Make sure overlay is covering everything, not just visible part of the screen
  $('.overlay').height $(document).height()
  $('.overlay').width $(document).width()
  $('.floatlabel').jvFloat()
  $('.touch .page-header nav').click ->
    $(this).find('.nav-container').toggleClass 'show'
  $('.tooltip').tooltipster()

  $ ->
    shrinkHeader = 100

    getCurrentScroll = ->
      window.pageYOffset or document.documentElement.scrollTop

    $(window).scroll ->
      scroll = getCurrentScroll()
      if scroll >= shrinkHeader
        $('.page-header').addClass 'shrink'
        $('.header-nav').addClass 'hide'
      else
        $('.page-header').removeClass 'shrink'
        $('.header-nav').removeClass 'hide'
    $('.page-header nav:before').click ->
      $(this).next('.nav-container').toggleClass('active')
    
  $(window).scroll ->
    if $('.sticky-nav').length != 0
      y = $(this).scrollTop()
      $('.sticky-nav a').each (event) ->
        if y >= $($(this).attr('href')).offset().top - 184
          $('.sticky-nav a').not(this).removeClass 'active'
          $(this).addClass 'active'

      if $('.sticky-nav').offset().top + $('.sticky-nav').height() > $('#ws-about').offset().top and $('.sticky-nav').offset().top < $('#ws-about').offset().top + $('#ws-about').height() or $('.sticky-nav').offset().top + $('.sticky-nav').height() > $('#ws-reviews').offset().top and $('.sticky-nav').offset().top < $('#ws-reviews').offset().top + $('#ws-reviews').height() or $('.sticky-nav').offset().top + $('.sticky-nav').height() > $('#contact-header').offset().top and $('.sticky-nav').offset().top < $('#contact-header').offset().top + $('#contact-header').height()
        $('.sticky-nav').addClass 'active'
      else
        $('.sticky-nav').removeClass 'active'

  $('.question h3').click ->
    $(this).parent('.question').toggleClass('active').find('.answer').slideToggle()

  $('[data-image]').click (event) ->
    image = $(this).data('image')
    title = $(this).attr('title')
    event.preventDefault()
    $('.lightbox').html '<figure><img src=\'' + image + '\'/><figcaption>' + title + '</figcaption></figure><a href=\'#\' class=\'close icon-cross\'></a>'
    $('.overlay').show()

  $('[data-video]').click (event) ->
    video = $(this).data('video')
    title = $(this).attr('title')
    event.preventDefault()
    $('.lightbox').html '<figure style="text-align: center"><iframe width="560" height="315" src="https://www.youtube.com/embed/' + video + '" frameborder="0" allowfullscreen></iframe><figcaption>' + title + '</figcaption></figure><a href=\'#\' class=\'close icon-cross\'></a>'
    $('.overlay').show()

  # Close modal on Escape key
  $(document).keydown (e) ->
    if e.keyCode == 27
      $('.overlay').fadeOut 100

  $('body').on 'click', '.close', (event) ->
    event.preventDefault()
    $('.overlay').fadeOut 100

  btnveh = $('.hero .btn-register').hasClass('btn-veh')
  btnklus = $('.hero .btn-register').hasClass('btn-klus')
  btnvve010 = $('.hero .btn-register').hasClass('btn-vve010')

  setveh = () ->
    sessionStorage.removeItem 'klus'
    sessionStorage.removeItem 'vve010'
    sessionStorage.setItem 'veh', 'true'
    $('.nav-container .btn-register').addClass 'btn-veh'
    $('.page-header .logo').addClass 'logo-veh'
    $('.page-header a.logo').attr 'href', '/nl/veh'
    $('.hero .btn-register').addClass 'btn-veh'
    $('a.btn-register').each (index, val) ->
      $(val).attr 'href', $(val).attr('href') + '?reference=veh'

  setklus = () ->
    sessionStorage.removeItem 'veh'
    sessionStorage.removeItem 'vve010'
    sessionStorage.setItem 'klus', 'true'
    $('.nav-container .btn-register').addClass 'btn-klus'
    $('.page-header .logo').addClass 'logo-klus'
    $('.page-header a.logo').attr 'href', '/nl/kluswebsite'
    $('.hero .btn-register').addClass 'btn-klus'
    $('a.btn-register').each (index, val) ->
      $(val).attr 'href', $(val).attr('href') + '?reference=kluswebsite'

  setvve010 = () ->
    sessionStorage.removeItem 'veh'
    sessionStorage.removeItem 'klus'
    sessionStorage.setItem 'vve010', 'true'
    $('.nav-container .btn-register').addClass 'btn-vve010'
    $('.page-header .logo').addClass 'logo-vve010'
    $('.page-header a.logo').attr 'href', '/nl/rotterdam'
    $('.hero .btn-register').addClass 'btn-vve010'
    $('a.btn-register').each (index, val) ->
      $(val).attr 'href', $(val).attr('href') + '?reference=rotterdam'

  if btnveh or btnklus or btnvve010
    if btnveh
      setveh()
    else if btnklus
      setklus()
    else if btnvve010
      setvve010()
  else
    if sessionStorage.getItem('veh')
      setveh()
    else if sessionStorage.getItem('klus')
      setklus()
    else if sessionStorage.getItem('vve010')
      setvve010()

  $('[data-mail]').click (event) ->
    mail = $(this).data('mail')
    event.preventDefault()
    $('.lightbox').html '<div class="modal-contact"><h2>Contact</h2><a href=\'mailto:' + mail + '\' class=\'button btn-mail anim-icon\'><span>' + mail + '</span></a> </div><a href=\'#\' class=\'close icon-cross\'></a>'
    $('.overlay').show()